'use client';

import React from 'react';
import PropTypes from 'prop-types';
import {
    AdvancedMarker,
    useAdvancedMarkerRef,
} from '@vis.gl/react-google-maps';

SearchMapMarker.propTypes = {
    data: PropTypes.object.isRequired,
    onMarkerSelect: PropTypes.func.isRequired,
};

export default function SearchMapMarker({ data, onMarkerSelect }) {
    const [markerRef, marker] = useAdvancedMarkerRef();

    const mapIcon = (
        <img
            src={
                data.flagship
                    ? '/wp-content/themes/bedrock-theme/static/images/clinics.svg'
                    : '/wp-content/themes/bedrock-theme/static/images/clinics.svg'
            }
            alt="Map Marker Icon"
            width={28}
            height={46}
        />
    );

    return (
        <>
            <AdvancedMarker
                ref={markerRef}
                onClick={() => onMarkerSelect(marker, data)}
                title={data.title}
                position={{
                    lat: data.lat,
                    lng: data.lng,
                }}
                zIndex={data.flagship ? 2 : 1}
            >
                {mapIcon}
            </AdvancedMarker>
        </>
    );
}
